export default {
  senha: null,
  confirmarSenha: null,
  token: null,
  mensagemSucesso: null,
  mensagemErro: null
}
